export default __webpack_public_path__ + "images/avatar_disco.2ad469e4.png";